var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formName && _vm.show)?_c(_vm.formName,{ref:"chosenDialog",tag:"component",attrs:{"loaded-info":_vm.loadedInfo},on:{"close":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }